// extracted by mini-css-extract-plugin
module.exports = {"power-backup-N":"N_power-backup-N__jfd8A"};